import Vue from 'vue';

Vue.filter('salutation', (value: string) => {
  if (!value) {
    return '';
  }

  if (value === 'male') {
    return 'Herr';
  }
  if (value === 'female') {
    return 'Frau';
  }

  return value;
});
